import React, { useContext } from 'react';
import { Col, Row as BSRow } from 'react-bootstrap';
import styled from 'styled-components';
import ReportChart from '../comps/ReportChart';
import TotalChart from '../comps/TotalChart';
import TotalReportForm from '../comps/TotalReportForm';
import { getProductsReportSum } from 'network/apis/ReportingApi';
import { useQuery } from 'react-query';
import { useAdminSelector } from 'admin-app/redux/admin.store';
import { DashboardContext } from 'context/DashboardContext';
import useScreen from 'hooks/useScreen';

const Holder = styled.div`
	margin: 0 0.7rem;
`;

const Row = styled(BSRow)`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	border-top-right-radius: ${(props) => props.toprightradius ? props.toprightradius : '0'};

	&.bottom {
		border-top-left-radius: 26px;
		border-top-right-radius: 26px;
	}
`;

const ProductTab = () => {
	const { currentTab } = useContext(DashboardContext);
	const filterState = useAdminSelector((store) => store.dashboardFilter);

	const { lessThan1200 } = useScreen();

	const { data: products, isLoading } = useQuery(
		['get-products-report', filterState.productsReportFilter],
		() => getProductsReportSum(filterState.productsReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'product'
		}
	);

	return (
		<Holder>
			<Row className='pt-3 pb-5'>
				<Col
					md={12}
					lg={12}
					xl={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'ps-5' : ''}`}
				>
					<TotalChart
						data={products?.list?.data?.items}
						tabName='product'
						isLoading={isLoading}
					/>
				</Col>
				<Col
					md={12}
					lg={12}
					xl={7}
				>
					<Row>
						<TotalReportForm
							reportType='product'
							data={products}
							isLoading={isLoading}
						/>
					</Row>
				</Col>
			</Row>
			{/* <BSRow className='mb-5 pb-4'>
				<Col
					md={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'ps-2' : ''}`}
				>
					<ReportChart reportType='product' />
				</Col>
				<Col md={7}>
				</Col>
			</BSRow> */}
		</Holder>
	);
};

export default ProductTab;
